import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import HelpButton from "../components/HelpButton";
import SEO from "../components/SEO";
import { generateServiceSchema } from "../lib/schema";

function NotFound() {
  return (
    <div className="min-h-screen bg-gray-50 page-transition pt-[99px] md:pt-[133px]">
      <SEO
        title="404 - Pagina niet gevonden - Elektraaanleggen.nl"
        description="De pagina die je zoekt bestaat niet meer of is verplaatst. Sorry voor het ongemak! Klik hier om terug te gaan naar de homepagina of probeer een andere pagina."
        schema={generateServiceSchema({
          name: "404 - Pagina niet gevonden",
          description:
            "De pagina die je zoekt is niet beschikbaar. Misschien is de URL veranderd, of de pagina is verwijderd. Ga terug naar de homepagina of probeer een andere link.",
          image: "https://elektraaanleggen.nl/images/banner.png",
        })}
      />

      <Header />

      <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1260px] flex grow py-16 justify-center items-center">
        <div className="">
          <div className="flex justify-center items-center flex-col">
            <h1 className="font-bold text-black leading-[1.25] text-[32px] lg:text-[48px] mb-6 text-center">
              Oeps... verdwaald!
            </h1>
            <div className="text-center text-black leading-[1.56] text-[16px] md:text-[18px] font-normal mb-10">
              De pagina die je zoekt bestaat niet meer of is verplaatst. Sorry
              voor het ongemak!
            </div>
            <Link
              to="/"
              className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#17354A] text-white hover:bg-[#17354A]/80 focus:bg-[#17354A]/80"
              style={{ minWidth: "181px" }}
            >
              <span className="flex items-center gap-1">
                Terug naar home
                <ArrowRight className="w-4 h-4" />
              </span>
            </Link>
          </div>
        </div>
      </section>

      <HelpButton />
      <Footer />
    </div>
  );
}

export default NotFound;
